import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"
const addInvoice = ( contract_id,duedate,description, notes,transaction_type,total_amount,rowData,extrafiledinvoice,payment_method) => {
  return axios.post(API + "billing/create/invoice/0/", {
    contract_id,
    duedate,
    description,
    notes,
    transaction_type,
    total_amount,
    rowData,
    extrafiledinvoice,
    payment_method
  },{headers: authHeader(),});
};
const AddInvoiceService = {
    addInvoice,
  };
  export default AddInvoiceService;